// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsuranceTwoToneSvg from "@ant-design/icons-svg/es/asn/InsuranceTwoTone";
import AntdIcon from '../components/AntdIcon';

var InsuranceTwoTone = function InsuranceTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsuranceTwoToneSvg
  }));
};

InsuranceTwoTone.displayName = 'InsuranceTwoTone';
export default React.forwardRef(InsuranceTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/InsuranceTwoTone.js
// module id = 1373
// module chunks = 0